/**
 * ControlsCenter
 * 
 * 职责：中央控制按钮（播放/暂停）
 */

import React from 'react';
import { PlayPauseButton } from './PlayPauseButton';

interface ControlsCenterProps {
  isPlaying: boolean;
  disabled: boolean;
  onPlayPauseClick: () => void;
}

export const ControlsCenter: React.FC<ControlsCenterProps> = ({
  isPlaying,
  disabled,
  onPlayPauseClick,
}) => {
  return (
    <div className="control-buttons-center">
      <PlayPauseButton
        isPlaying={isPlaying}
        disabled={disabled}
        onClick={onPlayPauseClick}
      />
    </div>
  );
};

